<template>

    <label
        class="c-form_upload"
        :class="getClasses"
        @dragover.prevent="updateDragDropFocus(true)"
        @dragleave.prevent="updateDragDropFocus(false)"
        @dragenter.prevent="updateDragDropFocus(true)"
        @drop.prevent="onFileChange">

        <input
            v-if="file === null"
            class="c-form_upload__input"
            type="file"
            :name="inputName"
            :accept="accept"
            @change="onFileChange"
            ref="input">


        <div class="c-form_upload__content">

            <div class="c-form_upload__tip">
                <span>Przeciągnij plik tutaj lub</span>
                <v-btn
                    type="green">
                    Załaduj plik ręcznie
                </v-btn>
            </div>

            <div class="c-form_upload__filename" v-if="editName">
                <form-input
                    label="Nazwa pliku"
                    :error="descError"
                    class="c-form_upload__filename-input"
                    v-model="fileDesc"
                    :speech-to-text="speechToText">
                </form-input>
                <div class="c-form_upload__filename-actions">
                    <v-btn
                        type="white"
                        @click="resetFile">
                        Anuluj
                    </v-btn>
                    <v-btn
                        type="green"
                        @click="uploadFile">
                        Zapisz
                    </v-btn>
                </div>

            </div>
            <div class="c-form_upload__uploading" v-if="uploading">
                <span>Zapisywanie pliku</span>
                <span class="c-form_upload__uploading-progress">{{ progress }}%</span>
                <div class="c-form_upload__uploading-progressbar">
                    <div class="c-form_upload__uploading-bar" :style="{ width: `${progress}%` }"></div>
                </div>
            </div>
        </div>


        <div class="c-form_upload__hover" v-if="file === null">
            <span class="c-form_upload__hover-icon"></span>
            <span>Upuść plik</span>
        </div>

    </label>

</template>


<script>

import FormInput from './FormInput'
import FormRow from './FormRow'
import VBtn from 'Components/VBtn'

export default {

    props: {
        name: String,
        accept: String,
        progress: Number,
        speechToText: Boolean
    },

    data() {
        return {
            inputName: this.name || 'files',
            file: null,
            fileDesc: '',
            dragDropFocus: false,
            dragDrop: true,
            editName: false,
            descError: '',
            uploading: false
        }
    },

    computed: {
        getClasses() {
            return {
                'c-form_upload--hovered': this.dragDropFocus
            }
        }
    },

    methods: {
        onFileChange(event) {
            if (this.dragDrop) {
                this.updateDragDropFocus(false)
            }
            const value = event.target.files || event.dataTransfer.files

            if (value && value.length) {
                if (this.dragDrop) {
                    if (value.length === 1) {
                        this.file = null
                    } else {
                        return false
                    }
                } else {
                    this.file = null
                }
                const file = value[0]
                if (this.checkType(file)) {
                    this.file = file
                    this.fileDesc = this.getFileName(file.name)
                    this.editName = true
                } else {
                    this.$alert.error('Załączniki', 'Niewłaściwy format pliku. Akceptowane formaty: ' + this.accept)
                    return false
                }
            }
        },
        updateDragDropFocus(focus) {
            this.dragDropFocus = focus
        },

        checkType(file) {
            if (!this.accept) return true
            const types = this.accept.split(',')
            if (types.length === 0) return true
            let valid = false
            for (let i = 0; i < types.length && !valid; i++) {
                const type = types[i].trim().toLowerCase()
                if (type) {
                    if (type.substring(0, 1) === '.') {
                        // check extension
                        const extIndex = file.name.lastIndexOf('.')
                        if (extIndex >= 0 && file.name.substring(extIndex).toLowerCase() === type) {
                            valid = true
                        }
                    } else {
                        // check mime type
                        if (file.type.match(type)) {
                            valid = true
                        }
                    }
                }
            }
            return valid
        },
        uploadFile() {
            if (this.fileDesc.trim() === '') {
                this.descError = 'Musisz podać nazwę pliku'
                return false
            }

            let formData = new FormData()
            formData.append('attachment', this.file)
            formData.append('description', this.fileDesc)

            this.$emit('upload', formData, this.resetFile)
            this.editName = false
            this.uploading = true
        },
        resetFile() {
            this.descError = ''
            this.descName = false
            this.editName = false
            this.file = null
            this.uploading = false
        },
        getFileName(fileName) {
            if (fileName && fileName.trim() === '') return ''
            const _tmp = fileName.split('.')
            if (_tmp.length > 1) return _tmp.slice(0, -1).join('.')
            else return _tmp[0]
        }
    },

    components: {
        FormRow,
        FormInput,
        VBtn
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_upload {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: 4px;
    border: 2px dashed $c-border;
    background-color: #F9FAFD;
    padding: 2rem;
    width: 100%;
    width: 100%;
    height: 12em;
    cursor: pointer;
    margin-bottom: 1rem;

    &__input {
        position: absolute;
        width: 1px;
        height: 0;
        opacity: 0;
        pointer-events: none;
    }
    &__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 100%;

        span {
            display: block;
            margin-bottom: 0.5rem;
        }
    }
    &__uploading {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        padding: 0 2rem;
        background-color: #F9FAFD;
        z-index: 6;
        text-align: center;

        span {
            margin-bottom: 0.5rem;
        }
        &-progress {
            display: block;
            color: $c-primary;
            font-size: 1.2rem;
            font-weight: 800;
        }
        &-progressbar {
            margin-top: 0.5rem;
            height: .8rem;
            width: 100%;
            box-shadow: inset 0 0 0 1px $c-primary;
            border-radius: 4px;
            overflow: hidden;
        }
        &-bar {
            transition: width .3s ease-in-out;
            height: 100%;
            background-color: $c-primary;
        }
    }
    &__filename {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 0 2rem;
        top: 0;
        left: 0;
        background-color: #F9FAFD;
        z-index: 5;

        &-input {
            text-align: left;
            max-width: 400px;
            margin-right: auto;
            margin-left: auto;
        }
        &-actions {
            display: flex;
            width: 100%;
            justify-content: space-between;
            max-width: 400px;
            margin-right: auto;
            margin-left: auto;
        }
    }
    &__hover {
        position: absolute;
        background-color: #F9FAFD;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        font-weight: 600;

        transition: opacity .2s ease-in-out, visibility 0s .2s linear;
        opacity: 0;
        z-index: 2;


        &-icon {
            display: inline-block;
            width: 3.2rem;
            height: 3.2rem;

            background-image: url('#{$icons}/file.svg');
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            margin-bottom: 1rem;
        }
    }
    &--hovered &__hover {
        transition-delay: 0s;
        opacity: 1;
    }
}

</style>
